import * as React from 'react';
import Box from '@mui/material/Box';
import { useUserContext } from '../../../../../../shared/context/user-context';
import { useFeatureFlagWithStatus } from '../../../../../../shared/featureFlags/useFeatureFlagWithStatus';
import { FeatureFlagKeys } from '../../../../../../shared/featureFlags/featureFlagKeys';
import NewsFeedDataLayer from '../../../../../../features/news/feed/NewsFeedDataLayer';
import TranslatedProjectNews from './NewsComponentDataLayer';

function EmptyBellPlaceUntilFlagIsKnown() {
    return <Box sx={{ width: '24px', height: '24px' }} />;
}

export default function NewsBellDelegate() {
    const { user } = useUserContext();
    const { value: showPublishedNews, isLoading } = useFeatureFlagWithStatus(
        FeatureFlagKeys.PublishedNewsForUsers,
        false
    );

    if (isLoading) {
        return <EmptyBellPlaceUntilFlagIsKnown />;
    }

    if (showPublishedNews && user.isAuthenticated) {
        return <NewsFeedDataLayer />;
    }

    return <TranslatedProjectNews userData={user.details.role} />;
}
